import React from 'react'
import { LIBERTY_IMAGES } from '../assets/asset'
import { useNavigate } from 'react-router-dom'
import { formatAddress, useWalletUI } from '../hooks/useWalletUI'

const XHeader = () => {
    const navigate = useNavigate()
    const { address, isConnected, openConnectModal } = useWalletUI()
    return (
        <>
            <header className="w-full fixed top-0 left-0 right-0 z-50 flex justify-between items-center px-3 md:px-5 py-3 md:py-4 bg-black/40 backdrop-blur-[25px]">
                <div className="flex items-center">
                    <a className="flex gap-2" href="/">
                        <img
                            alt="Liberty Swap"
                            width={120}
                            height={32}
                            decoding="async"
                            data-nimg={1}
                            className="w-auto h-8"
                            style={{ color: "transparent" }}
                            src={LIBERTY_IMAGES.LOGO}
                        />
                        <img
                            alt="Beta"
                            width={40}
                            height={20}
                            decoding="async"
                            data-nimg={1}
                            className="hidden md:block w-auto h-5"
                            style={{ color: "transparent" }}
                            src={LIBERTY_IMAGES.BETA_TAG}
                            data-savepage-loading="lazy"
                        />
                    </a>
                </div>
                <div className="flex justify-end items-center gap-1 md:gap-3">
                    <button onClick={() => navigate('/')} className="h-8 md:h-10 items-center justify-center bg-[#18181B] border border-[#242429] rounded-xl pl-1 pr-2">
                        <div className="flex items-center gap-1">
                            <img
                                alt="Chevron Left"
                                width={20}
                                height={20}
                                decoding="async"
                                data-nimg={1}
                                style={{ color: "transparent" }}
                                src={LIBERTY_IMAGES.IC_CHEVRON_LEFT}
                                data-savepage-loading="lazy"
                            />
                            <span className="text-sm font-medium text-white">Liberty Swap</span>
                        </div>
                    </button>
                    <div className="relative">
                        <div>
                            {!isConnected ? (
                                <button
                                    className="rounded-xl font-medium transition-all duration-300 cursor-pointer text-white hover:opacity-90 overflow-hidden   rounded-lg md:hidden"
                                    onClick={() => openConnectModal?.()}
                                    type="button"
                                >
                                <div>
                                    <div
                                        className="flex items-center justify-center px-4 h-8 text-sm "
                                        style={{ background: "var(--gradient-1)" }}
                                    >
                                        <div>
                                            Connect <span className="md:inline-block hidden">Wallet</span>
                                        </div>
                                    </div>
                                </div>
                                </button>
                            ) : null}
                            {isConnected ? (
                                <div
                                    role="button"
                                    tabIndex={0}
                                    className="hidden md:flex bg-[#242429] text-white px-4 py-2 rounded-xl text-sm hover:bg-[#2d2d33] transition-all duration-200 cursor-pointer items-center h-10"
                                >
                                    <img
                                        alt="MetaMask"
                                        loading="lazy"
                                        width={20}
                                        height={20}
                                        decoding="async"
                                        data-nimg={1}
                                        className="mr-2 rounded-sm"
                                        src={LIBERTY_IMAGES.METAMASK}
                                        style={{ color: "transparent" }}
                                    />
                                    {formatAddress(address)}
                                    <div className="hidden md:flex items-center justify-center relative ml-2">
                                        <button
                                            type="button"
                                            className="flex items-center justify-center hover:opacity-70 transition-opacity cursor-pointer"
                                            aria-label="Copy address"
                                            onClick={() => {
                                                if (address) navigator.clipboard?.writeText(address)
                                            }}
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={16}
                                                height={16}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                            >
                                                <path
                                                    stroke="#fff"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth="1.5"
                                                    d="M16 12.9v4.2c0 3.5-1.4 4.9-4.9 4.9H6.9C3.4 22 2 20.6 2 17.1v-4.2C2 9.4 3.4 8 6.9 8h4.2c3.5 0 4.9 1.4 4.9 4.9z"
                                                />
                                                <path
                                                    stroke="#fff"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth="1.5"
                                                    d="M22 6.9v4.2c0 3.5-1.4 4.9-4.9 4.9H16v-3.1C16 9.4 14.6 8 11.1 8H8V6.9C8 3.4 9.4 2 12.9 2h4.2C20.6 2 22 3.4 22 6.9z"
                                                />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            ) : (
                                <button
                                    className="rounded-xl font-medium transition-all duration-300 cursor-pointer text-white hover:opacity-90 overflow-hidden   rounded-lg md:block hidden"
                                    onClick={() => openConnectModal?.()}
                                    type="button"
                                >
                                    <div>
                                        <div
                                            className="flex items-center justify-center px-6 h-10 text-base "
                                            style={{ background: "var(--gradient-1)" }}
                                        >
                                            <div>
                                                Connect <span className="md:inline-block hidden">Wallet</span>
                                            </div>
                                        </div>
                                    </div>
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </header>

        </>
    )
}

export default XHeader